/** Public PT identity defaults; live contact settings remain authoritative. */
export const PT_PUBLIC_CONTACT = {
  address_line1: "R. do Parque Industrial 17",
  address_line2: "4750-734 Tamel (São Veríssimo), Barcelos",
  postal_code: "4750-734",
  city: "Tamel (São Veríssimo), Barcelos",
  country: "Portugal",
  email_general: "geral@hexatech.pt",
} as const;

export function publicCompanyIdentity(settings?: Record<string, string>) {
  const fields = { ...PT_PUBLIC_CONTACT, ...settings };
  const addressLine2 = fields.address_line2 || `${fields.postal_code} ${fields.city}`;
  return {
    addressLine1: fields.address_line1,
    addressLine2,
    country: fields.country,
    fullAddress: `${fields.address_line1}, ${addressLine2}${addressLine2.includes(fields.country) ? "" : `, ${fields.country}`}`,
    email: fields.email_general,
    postalCode: fields.postal_code,
    city: fields.city,
  };
}

/** Correct known outdated PT contact references without rewriting legal conditions. */
export function alignLegacyPublicContacts(content: string, identity: ReturnType<typeof publicCompanyIdentity>) {
  return content
    .replace(/Galegos Santa Maria, Barcelos, Portugal/g, identity.fullAddress)
    .replace(/hexatech\.geral@gmail\.com/g, identity.email);
}